






















import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { Mutation } from 'vuex-class'

@Component({
  computed: {
    ...mapState({
      userBalance: ({ gamblingContext }: any) => gamblingContext.userBalance.balance,
      pendingWithdrawals: ({ gamblingContext }: any) => gamblingContext.userBalance.pendingWithdrawals,
      bonus: ({ gamblingContext }: any) => gamblingContext.userBalance.bonus,
      currencyCode: ({ gamblingContext }: any) => gamblingContext.currencyCode,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout
    })
  }
})

export default class AccountBalance extends Vue {
  @Mutation('setAccountType') setAccountType: any
  @Mutation('setDrawerMiniVariant') setDrawerMiniVariant: any

  balanceDiv: boolean = false
  userBalanceUpdate: boolean = false
  userBalance!: number
  pageLayout!: string
  $routeChange!: any
  $smallScreen!: boolean
  $cashierConfigs!: any

  @Watch('watchUserBalance')
  onWatchUserBalance () {
    this.userBalanceUpdate = true
    setTimeout(() => {
      this.userBalanceUpdate = false
    }, 2300)
  }

  get accountBalanceIcon () {
    return this.balanceDiv ? 'mdi-chevron-up' : 'mdi-chevron-down'
  }
  get watchUserBalance () {
    return this.userBalance
  }

  seeBalance () {
    this.balanceDiv = !this.balanceDiv
  }

  toTransactions () {
    if (this.pageLayout === 'layout2' && !this.$smallScreen) {
      this.$routeChange('/gambling')
      setTimeout(() => {
        this.$cashierConfigs('mergeMultipleConfigs', {}, [
          'dynamicCashierType',
          'transactions'
        ], )
      }, 600)
      this.setDrawerMiniVariant(false)
    } else {
      this.setAccountType('history')
      this.$routeChange('/gambling/account')
    }
  }

}
